export default "__VITE_ASSET__Dq4D94J7__"